export const UPLOADER_VERSION_CHECK = 'VxuyrGsVWBy2SUKmmcY';
export const VERSION_CHECK = 'VxuyrGsVWBy2SUKmmcY';
export const VALID_VOTE = '20';

export const ACTION_TYPES = {
  VOTE: 'vote',
  INVALID: 'invalid'
}